__turbopack_context__.v({
  "container": "PaypalButton-module__tR3AXW__container",
  "dummyPaypalButton": "PaypalButton-module__tR3AXW__dummyPaypalButton",
  "errorMessage": "PaypalButton-module__tR3AXW__errorMessage",
});
